import cn from 'classnames';

import IconButton from '@/components/elements/IconButton';
import Trash from '@/components/Icon/Trash';
import { Skeleton } from '@/components/Skeleton';

import styles from './BannersBoxItem.module.scss';

type BannersBoxItemProps = {
  children?: React.ReactNode;
  className?: string;
  clearCTALabel?: string | React.ReactNode;
  clearDisabled?: boolean;
  icon?: string | React.ReactNode;
  isLoading?: boolean;
  onClearClick?: () => void;
  shortDescription?: string | React.ReactNode;
  title?: string | React.ReactNode;
};

const BannersBoxItem = ({
  children,
  className,
  clearCTALabel,
  clearDisabled,
  icon,
  isLoading,
  onClearClick,
  shortDescription,
  title,
}: BannersBoxItemProps) => {
  return (
    <div className={cn(styles.root, className)}>
      {isLoading ? (
        <>
          <Skeleton containerClassName={styles.skeleton} />
          <Skeleton containerClassName={styles.skeleton} />
        </>
      ) : (
        <>
          <div className={styles.description}>
            <span className={styles.icon}>{icon}</span>
            <div className={styles.titleBox}>
              <span className={styles.title}>{title} </span>
              &nbsp;
              <span>{shortDescription}</span>
            </div>
          </div>
          <div className={styles.dividedLine}>
            <div className={styles.cta}>
              <IconButton className={styles.clearButton} disabled={clearDisabled} onClick={onClearClick}>
                <Trash aria-hidden={true} />
                <span className={styles.label}>{clearCTALabel}</span>
              </IconButton>
            </div>
          </div>
        </>
      )}
      {children}
    </div>
  );
};

export default BannersBoxItem;
